/* HOTFIX-OVERRIDE — DISABLED.
   Original verhinderte den Cart-Drawer via Capture-Phase + stopImmediatePropagation
   und machte native Form-Submit zu /cart. Jetzt deaktiviert weil
   amariel-cart-drawer-patch.js die Drawer-Crashes abfängt und der ATC-Handler
   in amariel-magnesium-pdp-content-v3.liquid den Drawer korrekt öffnet. */
(function () {
  'use strict';
  console.log('[AmarielFix] HOTFIX disabled — drawer handles ATC now');
})();
